import { render } from "./BroadcastSettingsView.vue?vue&type=template&id=dda7738c&scoped=true"
import script from "./BroadcastSettingsView.vue?vue&type=script&lang=js"
export * from "./BroadcastSettingsView.vue?vue&type=script&lang=js"

import "./BroadcastSettingsView.vue?vue&type=style&index=0&id=dda7738c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda7738c"]])

export default __exports__